import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { DefaultLoader } from '#components/default-loader.tsx'
import { ImplementationsListPage } from '#features/implementations/implementations-list-page.tsx'

const searchSchema = z.object({
  filter: z.enum(['active', 'archived']).catch('active').default('active'),
})

export const Route = createFileRoute('/_app/$workspace/_dashboard/tasks/')({
  component: ImplementationsListPage,
  pendingComponent: DefaultLoader,
  validateSearch: searchSchema,
})
